import { Record } from 'immutable';
const UNINITIALIZED_INDEX = -1;
export class SecurityPhoneNumberSetupState extends Record({
  setupStepIndex: UNINITIALIZED_INDEX,
  stagedSMSNumber: '',
  isErrorSendingSMS: undefined,
  verificationCodeAttempt: '',
  verificationCodeFailure: false,
  redirectUrl: undefined
}) {}